import React from "react";
import "./timer.css";
class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTimerValueString:
        this.props.timerDuration < 10
          ? "0:0" + this.props.timerDuration
          : "0:" + this.props.timerDuration
    };

    this.currentTimerValue = this.props.timerDuration;
  }

  componentDidMount = () => {
    this.startTimer();
  };
  componentWillUnmount = () => {
    clearInterval(this.interval);
  };
  startTimer = () => {
    this.interval = setInterval(() => {
      if (this.currentTimerValue > 0) {
        this.currentTimerValue--;
        this.setState({
          currentTimerValueString:
            this.currentTimerValue < 10
              ? "0:0" + this.currentTimerValue
              : "0:" + this.currentTimerValue
        });
      } else {
        this.props.execUponExpiration();
        this.stopTimer();
      }
    }, 1000);
  };

  stopTimer = () => {
    clearInterval(this.interval);
    this.currentTimerValue = this.props.timerDuration;
    this.setState({
      currentTimerValueString:
        this.props.timerDuration < 10
          ? "0:0" + this.props.timerDuration
          : "0:" + this.props.timerDuration
    });
  };

  render() {
    return (
      <span
        className={
          this.props.isMentor ? "et-timer" : "et-timer et-timer-client"
        }
        id="et-timer-id"
      >
        {this.state.currentTimerValueString}
      </span>
    );
  }
}

export default Timer;
